import { useGetApiUserSettings, } from '../../generated/sitComponents';
import { CACHE_TIMES } from '../query';
export function useGetUserSettings(options) {
    return useGetApiUserSettings({}, {
        ...options,
        staleTime: CACHE_TIMES.FIVE_MINUTES,
        gcTime: CACHE_TIMES.THIRTY_MINUTES,
    });
}
export function useGetDefaultShowWeekends() {
    const { data } = useGetUserSettings();
    return data?.defaultShowWeekends ?? false;
}
//# sourceMappingURL=use-get-user-settings.js.map